import { render } from "./SolicitacoesClientesAdminView.vue?vue&type=template&id=25d99202"
import script from "./SolicitacoesClientesAdminView.vue?vue&type=script&lang=js"
export * from "./SolicitacoesClientesAdminView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__